module.exports = __webpack_public_path__ + "static/media/Josie Brody.7c89cbbc.png";